import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("cohnect_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // token expired — clear
      localStorage.removeItem("cohnect_token");
      localStorage.removeItem("cohnect_profile");
      if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin") && !window.location.pathname.endsWith("/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export function saveAuth(token, profile) {
  localStorage.setItem("cohnect_token", token);
  localStorage.setItem("cohnect_profile", JSON.stringify(profile));
}

export function getProfile() {
  try {
    return JSON.parse(localStorage.getItem("cohnect_profile") || "null");
  } catch {
    return null;
  }
}

export function clearAuth() {
  localStorage.removeItem("cohnect_token");
  localStorage.removeItem("cohnect_profile");
}

export function isAuthed() {
  return !!localStorage.getItem("cohnect_token");
}
